import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';

const fmtDate = (d: string | null) =>
  d ? new Date(`${d.slice(0, 10)}T00:00:00Z`).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' }) : '';

export default function PublicEscrowSummary() {
  const { token } = useParams();
  const [s, setS] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.getPublicEscrowSummary(token || '')
      .then((r) => (r.success ? setS(r.summary) : setErr(r.error || 'Not found')))
      .catch(() => setErr('Could not load'));
  }, [token]);

  if (err) return <div className="max-w-xl mx-auto p-8 text-center text-gray-500">{err}</div>;
  if (!s) return <div className="max-w-xl mx-auto p-8 text-center text-gray-400">Loading...</div>;

  return (
    <div className="max-w-xl mx-auto p-6">
      <h1 className="font-display text-[28px] font-semibold uppercase leading-[1.06] tracking-[-.01em] text-gray-900 sm:text-[32px]">{s.deal_name}</h1>
      <p className="text-sm text-gray-500">{[s.property?.address, s.property?.city].filter(Boolean).join(', ')}</p>
      <div className="mt-4 mb-6 bg-gray-50 rounded-lg p-4 flex gap-6">
        <div><p className="text-xs text-gray-500">Complete</p><p className="text-2xl font-semibold">{s.percent_complete}%</p></div>
        <div><p className="text-xs text-gray-500">Target close</p><p className="text-2xl font-semibold">{fmtDate(s.coe_date) || '-'}</p></div>
      </div>
      <div className="space-y-2">
        {s.milestones.map((m: any, i: number) => (
          <div key={i} className="flex items-center gap-3 border rounded-lg px-3 py-2">
            <span className={`w-2.5 h-2.5 rounded-full ${m.is_completed ? 'bg-success' : 'bg-gray-300'}`} />
            <span className={`flex-1 text-sm ${m.is_completed ? 'text-gray-500 line-through' : 'text-gray-900'}`}>{m.label}</span>
            <span className="text-xs text-gray-400">{fmtDate(m.due_date)}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-400 mt-6 text-center">Shared by Apex Real Estate Services</p>
    </div>
  );
}
